import React, { Component } from 'react';

import { fabric } from 'fabric';
import PropTypes from 'prop-types';

import { TEXT_CONFIGS } from '../constants';
import CanvasMenuButton from '../menu/CanvasMenuButton';

export default class CanvasAddText extends Component {
  static propTypes = {
    canvasRef: PropTypes.func,
    onUpdate: PropTypes.func,
    addingText: PropTypes.string
  };

  addText(value, options) {
    const { canvasRef } = this.props;
    const text = new fabric.Textbox(value, { ...options });

    canvasRef.add(text);
    canvasRef.setActiveObject(text);
    text.enterEditing();
  }

  getMousePosition(event) {
    const top = event.pointer ? event.pointer.y : 0;
    const left = event.pointer ? event.pointer.x : 0;

    return { top, left };
  }

  createText(event) {
    const { top, left } = this.getMousePosition(event);
    const canvas = event.e.target;
    const maxCanvasLeft = canvas.width - TEXT_CONFIGS.PADDING_TEXT_POSITION;
    const maxElementLeft = maxCanvasLeft - TEXT_CONFIGS.INITIAL_TEXT_WIDTH;
    const options = {
      top,
      left: Math.min(left, maxElementLeft),
      width: TEXT_CONFIGS.INITIAL_TEXT_WIDTH,
      fontSize: TEXT_CONFIGS.INITIAL_FONT_SIZE,
      editingBorderColor: TEXT_CONFIGS.EDITING_BORDER_COLOR,
      textAlign: TEXT_CONFIGS.INITIAL_TEXT_ALIGN,
      lockScalingY: true
    };

    this.addText('', options);
    this.disableClickEvent();
  }

  setCursor(cursor = 'default') {
    const { canvasRef } = this.props;

    canvasRef.defaultCursor = cursor;
  }

  enableClickEvent(func) {
    const { canvasRef } = this.props;

    this.setCursor('text');
    canvasRef.on('mouse:down', func);
  }

  disableClickEvent() {
    const { canvasRef } = this.props;

    canvasRef.off('mouse:down');
  }

  createMergedTag() {
    const { onUpdate } = this.props;

    onUpdate();
    this.enableClickEvent(this.createText.bind(this));
  }

  render() {
    const { addingText } = this.props;

    return (
      <CanvasMenuButton
        onClick={this.createMergedTag.bind(this)}
        toolTip="canvas-editor.text.add"
        icon="add-text"
        active={addingText}
        className="text-menu__button--large"
      />
    );
  }
}
